import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArrowDownOutlineStyle0 = gravityIconIndividualCss;

const GravityIconArrowDownOutline = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'b75ef91b09ea050515416e1222bbfc4b48ec0bb0', color: this.color, size: this.size }, h("svg", { key: '085696cc1e07909e57b60f9e8ee67be576de14d8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '0a9f8d4a30856968454e040992fc40113c707e02', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.36 15.18 5.82-5.83a.48.48 0 0 0 0-.7l-.35-.36a.51.51 0 0 0-.71 0L11 13.41 5.89 8.29a.51.51 0 0 0-.71 0l-.35.36a.48.48 0 0 0 0 .7l5.82 5.83a.51.51 0 0 0 .71 0Z", fill: "currentColor" }))));
    }
};
GravityIconArrowDownOutline.style = GravityIconArrowDownOutlineStyle0;

export { GravityIconArrowDownOutline as gravity_icon_arrow_down_outline };

//# sourceMappingURL=gravity-icon-arrow-down-outline.entry.js.map